var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomeMeasurementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9178 48.3651C14.4554 49.7452 4.56517 45.605 1.3887 35.1376C-2.2713 23.2938 1.25852 7.87534 12.5101 2.49283C26.3095 -3.83823 45.1116 6.65154 47.8231 22.773C49.735 37.3397 35.7756 47.1934 23.9215 48.3614",
    fill: "#FEC508"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7794_13819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 9,
    width: 32,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 9H8V41H40V9Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7794_13819)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7794_13819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 9,
    width: 32,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 9H8V41H40V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7794_13819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4469 37.0592H31.4289C31.9371 37.0592 32.3575 36.645 32.3575 36.1305V15.9517C32.3575 15.4435 31.9371 15.0231 31.4289 15.0231V35.2019C31.4289 35.7101 31.0085 36.1305 30.5003 36.1305H17.5183C17.5183 36.6388 17.9387 37.0592 18.4469 37.0592ZM17.5183 32.8866C17.5183 33.1439 17.7254 33.3509 17.9826 33.3509H23.5481C23.8054 33.3509 24.0124 33.1439 24.0124 32.8866C24.0124 32.6293 23.8054 32.4223 23.5481 32.4223H17.9826C17.7254 32.4223 17.5183 32.6293 17.5183 32.8866ZM17.5183 30.107C17.5183 30.3642 17.7254 30.5713 17.9826 30.5713H28.185C28.4422 30.5713 28.6493 30.3642 28.6493 30.107C28.6493 29.8497 28.4422 29.6427 28.185 29.6427H17.9826C17.7254 29.6427 17.5183 29.8497 17.5183 30.107ZM17.5183 27.3274C17.5183 27.5846 17.7254 27.7917 17.9826 27.7917H28.185C28.4422 27.7917 28.6493 27.5846 28.6493 27.3274C28.6493 27.0701 28.4422 26.8631 28.185 26.8631H17.9826C17.7254 26.8631 17.5183 27.0701 17.5183 27.3274ZM26.7983 21.1093C26.7983 21.6678 26.3465 22.1823 25.4932 22.1823C24.8344 22.1823 24.1944 21.8372 23.8054 21.0341L23.0775 21.6301C23.5105 22.5525 24.3701 23.0293 25.2548 23.1046V24.0897H25.9763V23.0795C27.0744 22.9164 27.8587 22.1509 27.8587 21.0654C27.8587 20.325 27.4822 19.7917 26.8611 19.4152C26.3654 19.114 25.4995 18.7501 25.123 18.518C24.7905 18.3109 24.5018 18.0223 24.5018 17.5768C24.5018 16.9807 24.9975 16.6105 25.6187 16.6105C26.083 16.6105 26.6164 16.8176 27.043 17.3823L27.7081 16.7611C27.2626 16.1462 26.6665 15.8388 26.0579 15.7321V14.816H25.3426V15.7133C24.1944 15.8262 23.4665 16.6293 23.4665 17.6333C23.4665 18.3925 23.8995 18.9384 24.5332 19.3337C25.0038 19.6348 25.5873 19.8607 26.0705 20.1054C26.472 20.3313 26.8109 20.6199 26.8109 21.1156L26.7983 21.1093ZM31.4289 37.9878H18.4469C17.4242 37.9878 16.5897 37.1595 16.5897 36.1305H15.6611C15.1528 36.1305 14.7324 35.7164 14.7324 35.2019V18.0474H18.905C19.9277 18.0474 20.7622 17.2191 20.7622 16.1901V12.0176H30.5003C31.0085 12.0176 31.4289 12.4317 31.4289 12.9462V14.0944C32.4516 14.0944 33.2861 14.9227 33.2861 15.9517V36.1305C33.2861 37.1533 32.4579 37.9878 31.4289 37.9878ZM18.9112 17.125H15.203L19.8399 12.4882V16.1964C19.8399 16.7046 19.4195 17.125 18.9112 17.125Z",
    fill: "#00625F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeMeasurementIcon);
export default __webpack_public_path__ + "static/media/income-measurement-icon.2135b09fb8a95925be86b69fea1f6856.svg";
export { ForwardRef as ReactComponent };